<div class="container">
  <div class="row">
    <div class="col-7 mt-3 mb-5 py-5 mx-auto">

      <div class="row mb-4">
        <div class="col-12">
          <h1>Trouble Signing In</h1>
          <p>We are sorry you are having trouble accessing your account.</p>
        </div>
      </div>

      <h6>WHAT DO YOU NEED HELP WITH?</h6>

      <div class="form-check">
        <input class="form-check-input" type="radio" name="troubleSigningInActionPicker" id="needToResetPasswordRadio"
               value="forgotPasswordAction" [(ngModel)]="troubleSigningInAction">
        <label class="form-check-label" for="needToResetPasswordRadio">
          I forgot/need to reset my password.
        </label>
      </div>

      <div class="form-check">
        <input class="form-check-input" type="radio" name="troubleSigningInActionPicker" id="forgotUsernameRadio"
               value="forgotUsernameAction" [(ngModel)]="troubleSigningInAction">
        <label class="form-check-label" for="forgotUsernameRadio">
          I forgot my username.
        </label>
      </div>

      <div class="form-check mb-3">
        <input class="form-check-input" type="radio" name="troubleSigningInActionPicker" id="verifyEmailRadio"
               value="verifyEmailAction" [(ngModel)]="troubleSigningInAction">
        <label class="form-check-label" for="verifyEmailRadio">
          I need to verify my email address.
        </label>
      </div>

      <div *ngIf="troubleSigningInAction == 'forgotPasswordAction'" [@showComponentWindow]>
        <app-forgot-password></app-forgot-password>
      </div>

      <div *ngIf="troubleSigningInAction == 'forgotUsernameAction'" [@showComponentWindow]>
        <app-forgot-username></app-forgot-username>
      </div>

      <div *ngIf="troubleSigningInAction == 'verifyEmailAction'" [@showComponentWindow]>
        <app-verify-email></app-verify-email>
      </div>

    </div>
  </div>
</div>
